import React from "react";
import { Link } from "react-router-dom";
import dobedo_logo from "../../assets/img/DOBEDO_LOGO.png";
import BookCallButton from "components/booking/BookCallButton";
import { ADDRESS, CONTACT, PRODUCTS, SERVICES, SOCIALS } from "config/site";
import "./footer.css";

const COMPANY_LINKS = [
  { to: "/about-us", label: "About Us" },
  { to: "/work", label: "Our Work" },
  { to: "/join-our-team", label: "Careers" },
  { to: "/contact-us", label: "Contact" },
  { to: "/privacy", label: "Privacy Policy" },
];

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer-cta">
          <div>
            <span className="site-footer-kicker">Let's build together</span>
            <h2>Have an idea? Let's turn it into a product.</h2>
            <p>Book a free 30-minute discovery call with our team — no sales pitch, just a clear plan.</p>
          </div>
          <div className="site-footer-cta-actions">
            <BookCallButton className="btn btn-white rounded site-footer-book">
              Book a discovery call
            </BookCallButton>
            <a href={`mailto:${CONTACT.email}`} className="site-footer-mail">
              or email {CONTACT.email}
            </a>
          </div>
        </div>

        <div className="site-footer-grid">
          <div className="site-footer-brand">
            <Link to="/" aria-label="Dobedo Soft home">
              <img src={dobedo_logo} alt="Dobedo Soft" className="site-footer-logo" />
            </Link>
            <p>
              An AI-first software studio building intelligent web, mobile and cloud products for
              startups and businesses worldwide.
            </p>
            <div className="site-footer-socials">
              {SOCIALS.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`Dobedo Soft on ${s.label}`}>
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="Services">
            <h3>Services</h3>
            <ul>
              {SERVICES.map((s) => (
                <li key={s.path}>
                  <Link to={s.path}>{s.name}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Company">
            <h3>Company</h3>
            <ul>
              {COMPANY_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Our products">
            <h3>Our Products</h3>
            <ul>
              {PRODUCTS.map((p) => (
                <li key={p.url}>
                  <a href={p.url} target="_blank" rel="noopener noreferrer">
                    {p.name} <i className="fa-solid fa-arrow-up-right-from-square site-footer-ext" />
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="site-footer-visit">
            <h3>Visit Us</h3>
            <address className="site-footer-address">
              <a href={ADDRESS.mapsUrl} target="_blank" rel="noopener noreferrer">
                {ADDRESS.line1},<br />
                {ADDRESS.line2},<br />
                {ADDRESS.country}
              </a>
            </address>
            <ul className="site-footer-contact">
              <li>
                <i className="fa-regular fa-envelope" />
                <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              </li>
              <li>
                <i className="fa-solid fa-phone" />
                <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="site-footer-bottom">
          <p>© {new Date().getFullYear()} Dobedo Soft. All rights reserved.</p>
          <p>Designed &amp; engineered in Surat, India — for clients worldwide.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
